import React from 'react';
import { NavLink } from 'react-router-dom';
import { Building2, LogOut, Plug } from 'lucide-react';
import { useAuthStore } from '../../store/auth';

const navItems = [
  { to: '/', icon: Building2, label: 'Companies', exact: true },
];

export const Sidebar: React.FC = () => {
  const logout = useAuthStore((state) => state.logout);

  return (
    <div className="w-64 h-screen fixed left-0 top-0 bg-black/40 backdrop-blur-md border-r border-cyan-500/30 p-4">
      <div className="flex items-center gap-2 mb-8">
        <Plug className="w-8 h-8 text-cyan-400" />
        <h1 className="text-xl font-semibold">Admin Portal</h1>
      </div>
      
      <nav className="space-y-2">
        {navItems.map(({ to, icon: Icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 rounded-md transition-colors ${
                isActive
                  ? 'bg-cyan-500/10 text-cyan-400'
                  : 'text-gray-400 hover:bg-cyan-500/5 hover:text-cyan-300'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            {label}
          </NavLink>
        ))}
      </nav>

      <button
        onClick={logout}
        className="flex items-center gap-3 px-4 py-2 text-red-400 hover:bg-red-500/10 rounded-md mt-auto absolute bottom-4 w-[calc(100%-2rem)]"
      >
        <LogOut className="w-5 h-5" />
        Logout
      </button>
    </div>
  );
};